import CloseIcon from "../../assets/CloseIcon.svg";
import { FC, ReactElement, useState } from "react";
import { BaseProps } from "./move-inRegistrationTabs/interfaces";

import ErrorSubscription from '../stores/ErrorSubscriptionStore';
import { observer } from "mobx-react";


interface Props extends BaseProps {
    id: string,
  }


const Error: FC<Props> = ({ id, onClick }: Props): ReactElement|null => {
  const [found, setFound] = useState(false);
  if(ErrorSubscription.errors[id])
    return (<p style={{color: 'red'}}>{ErrorSubscription.errors[id]}</p>)

  return null;
};

export default observer(Error);
